/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { string, arrayOf, object, shape } from "prop-types";
import classNames from "classnames/bind";
import merge from "lodash.mergewith";
// eslint-disable-next-line import/no-cycle
import { Link } from "../Link";
import { RCL } from "../../components/RCL";
import { Icon } from "../../components/Icons";
import * as sharedStyles from "./SocialFollowButtons.module.scss";

let cx = classNames.bind(sharedStyles);

const SocialFollowButtons = ({
	facebookPageLink,
	instagramPageLink,
	twitterPageLink,
	pinterestPageLink,
	youTubePageLink,
	tags,
	styles,
}) => {
	cx = classNames.bind(merge(sharedStyles, styles));

	return (
		<div className={cx("socialFollowButtonContainer", "socialFollowButtonContainerCustom")}>
			<div
				className={
					tags
						? cx("buttonsContainer", "buttonsContainerCustom", "seperated", "seperatedCustom")
						: cx("buttonsContainer", "buttonsContainerCustom")
				}>
				<span className={cx("followButtonsLabel", "followButtonsLabelCustom")}>
					<RCL searchKey="follow" />
				</span>

				{facebookPageLink && (
					<a
						href={facebookPageLink}
						target="_blank"
						className={cx(
							"socialMediaLink",
							"socialMediaLinkCustom",
							"facebook",
							"facebookCustom"
						)}>
						<Icon name="facebook" />
					</a>
				)}

				{instagramPageLink && (
					<a
						href={instagramPageLink}
						target="_blank"
						className={cx(
							"socialMediaLink",
							"socialMediaLinkCustom",
							"instagram",
							"instagramCustom"
						)}>
						<Icon name="instagram" />
					</a>
				)}

				{twitterPageLink && (
					<a
						href={twitterPageLink}
						target="_blank"
						className={cx("socialMediaLink", "socialMediaLinkCustom", "twitter", "twitterCustom")}>
						<Icon name="twitter" />
					</a>
				)}

				{pinterestPageLink && (
					<a
						href={pinterestPageLink}
						target="_blank"
						className={cx(
							"socialMediaLink",
							"socialMediaLinkCustom",
							"pinterest",
							"pinterestCustom"
						)}>
						<Icon name="pinterest" />
					</a>
				)}

				{youTubePageLink && (
					<a
						href={youTubePageLink}
						target="_blank"
						className={cx("socialMediaLink", "socialMediaLinkCustom", "youtube", "youtubeCustom")}>
						<Icon name="youtube" />
					</a>
				)}
			</div>

			{tags && (
				<div className={cx("tagsContainer", "tagsContainerCustom")}>
					{tags.map(tag => (
						<>
							{tag?.text?.includes("rending") ? (
								<></>
							) : (
								<Link to={tag.to} target={tag.target} className={cx("tag", "tagCustom")}>
									{tag.text}
								</Link>
							)}
						</>
					))}
				</div>
			)}
		</div>
	);
};

SocialFollowButtons.propTypes = {
	facebookPageLink: string,
	instagramPageLink: string,
	twitterPageLink: string,
	pinterestPageLink: string,
	youTubePageLink: string,
	tags: arrayOf(
		shape({
			to: string,
			target: string,
			text: string,
		})
	),
	styles: object,
};
SocialFollowButtons.defaultProps = {
	facebookPageLink: null,
	instagramPageLink: null,
	twitterPageLink: null,
	pinterestPageLink: null,
	youTubePageLink: null,
	tags: null,
	styles: null,
};

export default SocialFollowButtons;
export { SocialFollowButtons };
